import { useState } from "react";
import { EditSvg } from "../../icons";

import { Icards, ISubCategory } from "../../utils/types";
import classNames from "classnames";
import AddHotelCategoryDataModal from "./CategoryAddModal";

interface EditOfferProps {
  title: string;
  data: Icards | null;
  showIcon?: boolean;
  Icon?: any;
  defaultOpen?: boolean;
  onClose?: () => void;
  isDraftEditOffer?: boolean;
  disabled?: boolean;
  createNew?: boolean;
  isEditVideo?: boolean;
  categoryName: string;
  onSave?: (data: { categoryName: string; data: any } | FormData) => void;
  subCategoryData?: ISubCategory
}
const EditHotelCategory: React.FC<EditOfferProps> = ({
  title,
  data,
  showIcon = true,
  Icon,
  defaultOpen = false,
  onClose,
  disabled,
  isEditVideo= false,
  categoryName,
  onSave = () => {},
  subCategoryData,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(defaultOpen);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  return (
    <>
      {showIcon ? (
        Icon ? (
          <div onClick={disabled ? undefined : openModal}>{Icon}</div>
        ) : (
          <div
            onClick={disabled ? undefined : openModal}
            className={classNames(
              "h-8 w-8 rounded-full bg-[#EFF6FF] flex items-center justify-center hover:bg-[#DBEAFE] transition-colors",
              disabled ? "opacity-50" : "cursor-pointer"
            )}
          >
            <EditSvg color="#6362E7" />
          </div>
        )
      ) : null}
      <AddHotelCategoryDataModal
        data={data!}
        isEdit={isEditVideo}
        categoryName={categoryName}
        onSuccess={() => closeModal()}
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalTitle={title}
        onSave={onSave}
        subCategoryData={subCategoryData}
      />
      {/* </div>
      </Modal> */}
    </>
  );
};

export default EditHotelCategory;
